import React from 'react'
import { useStateValue } from '@State'
import { TemplateTable } from './TemplateTable'

export const TemplateTables = () => {
  let [currentState] = useStateValue()
  return (
    <div className="d-flex w-100">
      <div className="w-50">
        <TemplateTable tempType="badge" templates={currentState.badges} />
      </div>
      <div className="w-50">
        <TemplateTable
          tempType="certificate"
          templates={currentState.certificates}
        />
      </div>
    </div>
  )
}
